import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { SubHeadline } from '~components/Typography';
import { SmartElement } from '~shared/ui/atoms';
import { ButtonPrimary } from '~shared/ui/molecules/Buttons/ButtonPrimary';
import { MqTablet } from '~theme/media';

export const Text = styled(SubHeadline)`
	text-transform: capitalize;
`;

export const StyledCardButton = styled(SmartElement)`
	position: relative;
	display: flex;
	overflow: hidden;
	flex-shrink: 0;
	border: 2px solid var(--color-grey-6-solid);
	border-radius: var(--radius-m);
	transition: border var(--button-transition-duration) box-shadow
		var(--button-transition-duration);

	&.clickable {
		cursor: pointer;
	}

	&.clickable:hover:not(.selected, div) {
		box-shadow: 0 0 0 2px var(--color-white-xs);

		& > svg {
			display: block;
			opacity: 0.2;
		}
	}

	&:focus:not(.selected) {
		border-color: var(--color-white-solid);
		box-shadow: 0 0 0 3px var(--color-white-solid);
	}

	&:active:not(.selected) {
		border-color: var(--color-grey-6-xl);
		box-shadow: 0 0 0 2px var(--color-grey-6-xl);
	}

	&.clickable > svg {
		position: absolute;
		top: 1rem;
		right: 1rem;
		display: none;
	}

	&.selected {
		box-shadow: 0 0 0 3px var(--color-white-solid);

		> svg {
			display: block;
		}
	}

	&.square {
		aspect-ratio: 1 / 1;
	}

	&.vertical {
		aspect-ratio: 2 / 3;
	}

	&.horizontal {
		aspect-ratio: 3 / 2;
	}

	${MqTablet} {
		&.desktop-square {
			aspect-ratio: 1 / 1;
		}

		&.desktop-vertical {
			aspect-ratio: 2 / 3;
		}

		&.desktop-horizontal {
			aspect-ratio: 3 / 2;
		}
	}
`;
export const imageStyle = css`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const Neurons = styled.div`
	position: absolute;
	top: 0.6rem;
	left: 0.6rem;
	display: flex;
	align-items: center;
	padding: 2px 6px;
	border-radius: var(--radius-xl);
	backdrop-filter: blur(5px);
	background-color: var(--color-white-xs);
	gap: 4px;
`;

export const Content = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	display: flex;
	width: 100%;
	height: 9rem;
	align-items: flex-end;
	justify-content: center;
	padding-right: 6px;
	padding-bottom: 1rem;
	padding-left: 6px;
	background: linear-gradient(
		180deg,
		transparent 0%,
		var(--color-black-l) 100%
	);
`;

export const Badge = styled(ButtonPrimary)`
	position: absolute;
	top: 0.8rem;
	right: 0.8rem;
`;

export const ComingSoon = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
	color: var(--color-grey-85-solid);
`;
